// Kept out of SubscriptionOverrideForm.tsx so that file only exports components (react-refresh).
export type OverridePlanTier = "individual" | "team" | "organization"

export function normalizeOverridePlanTier(tier?: string | null): OverridePlanTier | null {
  switch (tier) {
    case "individual":
      return "individual"
    case "basic":
    case "team":
      return "team"
    case "pro":
    case "organization":
      return "organization"
    default:
      return null
  }
}
